<template>
  <ul class="content-info-links">
    <li v-for="link in links" :key="link.to" class="content-info-links__item">
      <nuxt-link class="content-info-links__link" :to="link.to">
        {{ link.title }}
      </nuxt-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ContentInfoLinks',

  props: {
    links: {
      type: Array,
      required: true,
    },
  },
}
</script>
